import { useHasAccess } from 'lib-shared-access-control';
import { Route, Routes } from 'react-router-dom';

import { NotFoundView } from '../../../notFound';

import { SettingsQueuesView } from './settingsQueues.view';
import { SettingsQueuesCreateView } from './views/create';
import { SettingsQueuesEditView } from './views/edit';

export const SettingsQueuesRoutes = (): JSX.Element => {
  const hasQueueReadAccess = useHasAccess('settings.queue:r');
  const hasQueueWriteAccess = useHasAccess('settings.queue:w');
  const hasQueueEditAccess = useHasAccess(
    ['settings.queue.offering', 'settings.queue.members'],
    { strategy: 'any' },
  );

  return (
    <Routes>
      <Route path="*">
        {hasQueueReadAccess && <Route index element={<SettingsQueuesView />} />}

        {hasQueueWriteAccess && (
          <Route path="create" element={<SettingsQueuesCreateView />} />
        )}

        {hasQueueEditAccess && (
          <Route path=":id" element={<SettingsQueuesEditView />} />
        )}

        <Route
          path="*"
          element={
            <NotFoundView navigatePath="/settings/queues" name="Queues" />
          }
        />
      </Route>
    </Routes>
  );
};
